import KUuid from '../../core/utils/KUuid'

export default {
  name: 'KTabPane',
  inject: ['context'],
  props: {
    tab: {
      type: String,
      default: '',
    },
    // unique key, 如果Tabs绑定了v-model，则需要为每个TabPane提供唯一的标志
    name: {
      type: String,
      default: '',
    },
    // 仅在 tabs 为 editable 时有效
    closable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      rendered: false,
      id: KUuid(),
    }
  },
  computed: {
    isActive() {
      return this.id === this.context.activePaneId
    },
  },
  watch: {
    name: {
      immediate: true,
      handler(name) {
        if (name) {
          this.id = this.name
        }
      },
    },
    isActive: {
      immediate: true,
      handler(active) {
        this.$emit(active ? 'active' : 'inactive')
      },
    },
  },
  created() {
  },
  mounted() {
    // this.$emit('pane-mounted', this)
    this.context.updatePane(this)
  },
  updated() {
    this.context.updatePane(this)
  },
  destroyed() {
    this.context.removePanel(this)
  },
  methods: {
    focus() {
      this.$el.focus()
    },
  },
  render() {
    if (this.isActive) {
      this.rendered = true
    }

    if (!this.rendered) {
      return null
    }

    const style = {}

    const css = {
      'km-tab-pane': true,
      'km-tab-pane--active': this.isActive,
    }

    if (this.size) {
      css[`is-${this.size}`] = true
    }

    const attrs = {
      disabled: this.disabled,
    }

    // const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
    }

    return <div {...data}>{this.$slots.default}</div>
  },
}
